import type { DynamicValuePart, DynamicValues } from './types';

const DYNAMIC_VALUE_EXPRESSION = /\{(\w+)\}|@@(\w+)@@/g;

export class DynamicValueReplacer {
  static splitAndCapture(text: string): Array<DynamicValuePart> {
    const parts: Array<DynamicValuePart> = [];
    let lastIndex = 0;
    let match;

    while ((match = DYNAMIC_VALUE_EXPRESSION.exec(text)) !== null) {
      if (match.index > lastIndex) {
        parts.push(text.substring(lastIndex, match.index));
      }

      if (match[1]) {
        // Matched curly braces
        parts.push({ key: match[1], match: match[0] });
      } else if (match[2]) {
        // Matched double @ symbols
        parts.push({ key: match[2], match: match[0] });
      }

      lastIndex = match.index + match[0].length;
    }

    if (lastIndex < text.length) {
      parts.push(text.substring(lastIndex));
    }

    return parts;
  }

  static replace(text: string, dynamicValues: DynamicValues): string {
    return text.replace(DYNAMIC_VALUE_EXPRESSION, (match, key1, key2) => {
      if (Array.isArray(dynamicValues)) {
        // Array-based replacement (indexed placeholders)
        const index = parseInt(key1 || key2, 10); // Use key1 or key2 (whichever is present)
        if (!isNaN(index) && dynamicValues[index] !== undefined) {
          return String(dynamicValues[index]); // Ensure it's a string
        }
        return match; // Leave unchanged if index is invalid or value is missing
      } else {
        // Record-based replacement (named placeholders)
        const key = key1 || key2; // Use key1 or key2 (whichever is present)
        if (key && dynamicValues && dynamicValues[key] !== undefined) {
          return String(dynamicValues[key]); // Ensure it's a string
        }
        return match; // Leave unchanged if key is missing or value is missing
      }
    });
  }
}
